import {
  Globe, Smartphone, LayoutDashboard, Users, Network, Magnet, FileBarChart,
  Layers, Building2, Landmark, Contact, GitBranch, Zap, IdCard, User, Briefcase,
  Home, Building, Car, CreditCard, Shield, LineChart, Receipt, Circle,
} from "lucide-react";

const MAP = {
  globe: Globe, smartphone: Smartphone, "layout-dashboard": LayoutDashboard,
  users: Users, network: Network, magnet: Magnet, "file-bar-chart": FileBarChart,
  layers: Layers, "building-2": Building2, landmark: Landmark, contact: Contact,
  "git-branch": GitBranch, zap: Zap, "id-card": IdCard, user: User,
  briefcase: Briefcase, home: Home, building: Building, car: Car,
  "credit-card": CreditCard, shield: Shield, "line-chart": LineChart, receipt: Receipt,
};

export function LandingIcon({ name, className }) {
  const Cmp = MAP[name] || Circle;
  return <Cmp className={className} />;
}
